(function (angular, app) {
    'use strict';
    app.directive('spPromotion', [function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                size: '=',
                product: '=?',
                special: '=?',
                isCart: '=?',
                isList: '=?',
                isProduct: '=?',
                isSpecial: '=?',
                productSpecial: '=?',
                withoutActions: '@?',
                isCase: '=?',
                specials: '<?',
                specialToShow: '<?',
                isShowTprDisplay: '<?',
                productForPrice: '<?'
            },
            templateUrl: 'template/directives/sp-promotion/index.html',
            controller: ['$scope', '$rootScope', '$state', '$timeout', 'Util', 'Cart', 'spSpecialTypeChecker', function ($scope, $rootScope, $state, $timeout, Util, Cart, spSpecialTypeChecker) {
                $scope.toggleTooltip = function(event) {
                    event.stopPropagation();
                    if (event.currentTarget) {
                        event.currentTarget.blur();
                    }
                    $rootScope.promotionTooltip = $scope.promotionId;

                    if ($scope.isCart) {
                        $scope.bottomTooltip = event.currentTarget.getBoundingClientRect().top < 300;
                        $scope.toolbarHeight = angular.element(document.querySelector('header > div.toolbar'))[0].clientHeight;
                        var totalTipCalc = ($scope.bottomTooltip ? 
                            event.currentTarget.getBoundingClientRect().bottom - ($scope.toolbarHeight > 70 ? $scope.toolbarHeight : 0) : 
                            window.innerHeight - event.currentTarget.getBoundingClientRect().top) + 6;
                        
                        $scope.tooltipPosition = totalTipCalc +'px';

                        // temporay solution for prutah template
                        $scope.prutahTooltipPosition = totalTipCalc + ($scope.bottomTooltip ? -135 : 135) + 'px';
                    }

                    $timeout(function () {
                        _setFocusOnElement($scope.promotionId);
                    });
                }

                $scope.closeTooltip = function () {
                    $rootScope.promotionTooltip = null;
                    _setFocusOnElement($scope.isCart ? $scope.promotionTagId : $scope.promotionWrapperId);
                }

                $scope.openSpecial = function (special, showProductsFrom) {
                    // Emit ECOM-17469 Special Selected event
                    var source = $rootScope.SP_SERVICES.SOURCES.PROMOTION_PAGE;
                    var index = (typeof showProductsFrom === 'number' && !isNaN(showProductsFrom)) 
                                ? showProductsFrom 
                                : (showProductsFrom && showProductsFrom.index !== undefined && !isNaN(showProductsFrom.index))
                                    ? showProductsFrom.index 
                                    : undefined;

                    var mixpanelProperties = {};
                    mixpanelProperties[$rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_SPECIAL_SELECTED] = {
                        promotionId: special.id,
                        promotionType: spSpecialTypeChecker.getSpecialType(special) || $rootScope.SP_SERVICES.MIXPANEL_VALUES.UNKNOWN,
                        source: source,
                        specialPosition: index !== undefined 
                            ? source + ' Position At ' + (index + 1).toString() 
                            : $rootScope.SP_SERVICES.MIXPANEL_VALUES.UNKNOWN,
                        productImageUrl: special.frontendImageUrl
                    };

                    $rootScope.spMixPanel.trackPreviousProperties(mixpanelProperties);
                    
                    $state.go('app.specials.special', {sid: special.id});
                };

                $scope.showSpecialDetails = function (event, productId) {
                    // ECOM-17470 Click & Save Selected - Save to localStorage
                    var previousProperties = {};
                    previousProperties[$rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_CLICK_SAVE_SELECTED] = {
                        specialId: $scope.specialToShow.id,
                        productId: productId ? productId : ($scope.product ? $scope.product.id : null),
                    }
                    $rootScope.spMixPanel.trackPreviousProperties(previousProperties);

                    event.stopPropagation();
                    var showProductsFrom = Cart.specialReminders.onProducts &&
                        Cart.specialReminders.onProducts[$scope.specialToShow.id] &&
                        Cart.specialReminders.onProducts[$scope.specialToShow.id].showProductsFrom;
                    return Util.showSpecialDetailsDialog($scope.specialToShow.id, showProductsFrom);
                }

                $scope.isNotEmptyObject = function(obj) {
                    return obj && Object.keys(obj).length > 0;
                };

                function _getSpecialDescription(icons, clubId, langId) {
                    if (!icons || clubId === undefined) return '';
                    return (icons[clubId] && icons[clubId][langId] && icons[clubId][langId].description) ||
                           (icons[clubId] && icons[clubId][2] && icons[clubId][2].description) ||
                           '';
                }

                function init(){
                    $scope.promotionId = 'promotion_tooltip_' + ($scope.product ? $scope.product.id : $scope.special.id) + ($scope.isCart ? '_cart' : '') + ($scope.product && $scope.isCase ? '_caseMode' : '');
                    $scope.promotionWrapperId = 'promotion_wrapper_' + ($scope.product ? $scope.product.id : $scope.special.id) + ($scope.isCart ? '_cart' : '') + ($scope.product && $scope.isCase ? '_caseMode' : '');
                    $scope.promotionTagId = 'promotion_tag_' + ($scope.product ? $scope.product.id : $scope.special.id) + ($scope.isCart ? '_cart' : '') + ($scope.product && $scope.isCase ? '_caseMode' : '');

                    if (!$scope.specials) {
                        $scope.specials = $scope.product ? Util.filterProductSpecials($scope.isCase || $scope.product.branch.case ? $scope.product.branch.case : $scope.product.branch): [$scope.special];
                    }
                    if (!$scope.specialToShow) {
                        $scope.specialToShow = Util.getSpecialToShow($scope.specials);
                    }
                    $scope.productForPrice = $scope.productForPrice || $scope.product || $scope.special.item || $scope.special.groupRepresentative;
                    if ($scope.isShowTprDisplay === null || $scope.isShowTprDisplay === undefined) {
                        $scope.isShowTprDisplay = false;
                        if ($rootScope.config.isUs &&
                            $rootScope.config.retailer.settings.isNewPromotionDesignEnabled === 'true' &&
                            $scope.productForPrice &&
                            $scope.specialToShow &&
                            $scope.specialToShow.isTPRPromotion
                        ) {
                            $scope.isShowTprDisplay = true;
                        }
                    }

                    var icons = $scope.specialToShow && $scope.specialToShow.icons;
                    var loyaltyClubsIds = $scope.specialToShow && $scope.specialToShow.loyaltyClubsIds;
                    var clubId = Array.isArray(loyaltyClubsIds) && loyaltyClubsIds.length > 0 
                        ? loyaltyClubsIds[0] 
                        : undefined;
                    var langId = $rootScope.config && $rootScope.config.language && $rootScope.config.language.id;
                    
                    $scope.specialDescription = _getSpecialDescription(icons, clubId, langId);
                }

                function _setFocusOnElement(id) {
                    var element =  document.getElementById(id);
                    !!element && element.focus();
                }

                $scope.$watch('product', function(){
                    init();
                });
                $scope.$watch('isCase', function(newValue, oldValue) {
                    if (newValue !== oldValue) {
                      init();
                    }
                });

                Util.currentScopeListener($scope, $rootScope.$on('cart.closed', function () {
                   $scope.closeTooltip();
                }));
                // init();
            }]
        };
    }]);
})(angular, app);
